module.exports = __webpack_public_path__ + "img/idcardFrontUrl.73e07ad0.png";